import React, { useEffect, useState } from 'react'
import './ProductoComplementario.scss'
import { EquisIcons } from '../utils/icons'
import { DobleGuion } from './DobleGuion'
import { ProductoDetalleDescripcion } from '../components/ProductoDetalleDescripcion'
import { ProductoDetalleCaracteristicas } from '../components/ProductoDetalleCaracteristicas'
import ProductoDetalleFormato from '../components/ProductoDetalleFormato'
import ProductoDetalleCantidad from '../components/ProductoDetalleCantidad'
import ProductoDetalleTotal from '../components/ProductoDetalleTotal';
import ProductoDetalleBtnCompra from '../components/ProductoDetalleBtnCompra'
import Separator from '../components/Separator';
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom';
import { firstCharCapitalize } from '../utils/utils'
import { privilegeUser } from '../hooks/user'
import {OptionsProductDesactivate} from './OptionsProductDesactivate'
import _ from 'lodash';

const ProductoComplementario = (props) => {
    const { product, clickClose } = props
    const [privilege, setPrivilege] = useState(undefined)

    useEffect(() => {
        getPrivilege()
    }, [])

    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    return (
        <div className="producto-complementario-container">
            <div className="content">
                <div className="header">
                    <div className="title">
                        <div className="text">
                            <p>PRODUCTO COMPLEMENTARIO</p>
                            <DobleGuion />
                        </div>
                        <div className="botones">
                            <button className="pointer" onClick={clickClose}><EquisIcons size={15} /></button>
                        </div>
                    </div>
                </div>
                <div className="product">
                    <div className="title">
                        <p>{firstCharCapitalize(product.Nombre)}</p>
                        {product.Estado === 'NUEVO' || product.Estado === 'PROXIMAMENTE' &&
                            <p className="nuevo"><span>NUEVO</span></p>
                        }
                    </div>
                    <div className="img">
                        <img src={"/static/imgProducts/" + product.Fotografia + "_p.jpg"} onError={(e) => {
                            e.target.onerror = null
                            e.target.src = '/static/img/no-imagen-fansa.png'
                        }} alt="" />
                    </div>
                    <div className="details-uno">
                        <div className="separator"><Separator /></div>
                        <div><ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion></div>
                        <div className="separator"><Separator /></div>
                    </div>
                    <div className="details-dos">
                        <div className="separator"><Separator /></div>
                        <div><ProductoDetalleCaracteristicas producto={product} variaciones={{}} /></div>
                    </div>
                    <div className="options">
                        {!_.isEmpty(props.userActive) ?
                            <React.Fragment>
                                <div className="format"><ProductoDetalleFormato producto={product}></ProductoDetalleFormato></div>
                                <div><ProductoDetalleCantidad producto={product} /></div>
                                <div className="separator"><Separator /></div>
                                <div className="total"><ProductoDetalleTotal producto={product}></ProductoDetalleTotal></div>
                                <div className="separator"><Separator /></div>
                                <div className="boton-compra"><ProductoDetalleBtnCompra product={product}></ProductoDetalleBtnCompra></div>
                                <div className="precio">
                                    {privilege &&
                                        <p>Precio de venta recomendado <strong>{product.PrecioTarifa}€</strong></p>
                                    }
                                </div>

                            </React.Fragment>
                            :
                            <OptionsProductDesactivate></OptionsProductDesactivate>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(ProductoComplementario)